import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import InputDialog from "../../components/InputDialog.js";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";
import copyImg from "../../assets/icons/copy.png";
import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import scoreImg from "../../assets/icons/score.png";
import previewImg from "../../assets/icons/preview.png";

import {
  FIND_FORM_FOR_CLIENT_QUERY,
  CREATE_FORM_MUTATION,
} from "../../graphQL/form_qry";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;
const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "8rem",
    marginRight: "8rem",
    marginTop: "2rem",
    textAlign: "center",
    padding: theme.spacing(2),
    minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "2rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    //  minWidth: "1000px",
    height: "600px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function FormContainer() {
  const classes = useStyles();
  const { handleSubmit } = useForm();

  const navigate = useNavigate();
  const [publishStatus, setPublishStatus] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [inputDialogMsg, setInputDialogMsg] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [failedMessage, setFailedMessage] = useState("");

  const [fetchForm] = useManualQuery(FIND_FORM_FOR_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });

  const [createForm] = useMutation(CREATE_FORM_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "date",
      headerName: "Date of Creation",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "sprint",
      headerName: "Sprint",
      minWidth: 140,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        return <Link to="">{rows.row.sprint}</Link>;
      },
    },
    {
      field: "url",
      headerName: "URL",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      // renderCell: (rows) => {
      //   return <Link to="/">{rows.row.url}</Link>;
      // },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (publishStatus) return <a>Published</a>;
        else return <a>Draft</a>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {!publishStatus ? (
              <StyledTooltip title="Publish this form">
                <img
                  style={{
                    paddingRight: 15,
                    cursor: "pointer",
                    paddingTop: 6,
                    height: 24,
                    weight: 24,
                    paddingTop: 6,
                  }}
                  src={publishImg}
                  onClick={() => setPublishStatus(true)}
                />
              </StyledTooltip>
            ) : (
              <StyledTooltip title="Unpublish this form">
                <img
                  style={{
                    paddingRight: 15,
                    cursor: "pointer",
                    paddingTop: 6,
                    height: 24,
                    weight: 24,
                    paddingTop: 6,
                  }}
                  src={unpublishImg}
                  onClick={() => setPublishStatus(false)}
                />
              </StyledTooltip>
            )}
            <StyledTooltip title="Assign scores">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  height: 24,
                  weight: 24,
                  paddingTop: 6,
                }}
                src={scoreImg}
              />
            </StyledTooltip>
            <StyledTooltip title="Copy this form">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  height: 24,
                  weight: 24,
                  paddingTop: 6,
                }}
                src={copyImg}
                onClick={() =>
                  setAlertMsg({
                    title: "STP - sprint 4 URL is copied!",
                    type: "Done",
                    msg: "Now you can send it to other people by using CTRL+V.",
                  })
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Preview">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  height: 24,
                  weight: 24,
                  paddingTop: 6,
                }}
                src={previewImg}
              />
            </StyledTooltip>
            <StyledTooltip title="Edit this form">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                }}
                src={penImg}
              />
            </StyledTooltip>
            <StyledTooltip title="Delete this form">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                }}
                src={trashImg}
                onClick={() =>
                  setAlertMsg({
                    title: "Delete “STP-sprint 4”",
                    type: "deleteConfirmation",
                    msg:
                      "Are you sure you want to delete this form? all your questions will be disappeared.",
                  })
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];
  const rows = [
    {
      id: "1",
      name: "STP - sprint 4",
      date: "03/18/2024",
      sprint: "Client - sprint 4",
      url: "http://client - sprint 4",
      status: "Draft",
    },
  ];

  /*
   * Function : onSubmit
   * Description : Submit form data
   */
  const onSubmit = async (formName) => {
    /*const {
        loading: formLoading,
        error: formError,
        data: formData,
      } = await fetchForm({
        variables: {
          clientId: parseInt(1),
          name: formName,
        },
      });

      if (!formLoading && formData && formData.findFormForClient) {
        alert(formData.findFormForClient)
      }*/

    const { data, error } = await createForm({
      variables: {
        name: formName,
        clientId: 1,
      },
    });
    if (error) {
      console.log("Error", error, data);
      setFailedMessage("Unfortunately an error occurred.");
      setTimeout("");
    } else if (data && data.createForm) {
      console.log("Success", data);

      navigate(`${project_url}/forms/myforms/${data.createForm.form.formId}`);
    }
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Forms
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              onClick={() =>
                setInputDialogMsg({
                  title: "Form Name",
                  msg: "Enter form name",
                })
              }
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.container}>
        <DataGrid
          className={classes.dataGridStyle}
          columns={columns}
          rows={rows}
          showCellRightBorder={true}
          hideFooter={true}
          slots={{
            toolbar: DataGridTitle,
          }}
          getRowId={(row) => row.id}
          autoHeight={true}
          experimentalFeatures={{ newEditingApi: true }}
        />
        {alertMsg.msg && (
          <AlertDialog
            title={alertMsg.title}
            type={alertMsg.type}
            contentMsg={alertMsg.msg}
            closeDialog={() => setAlertMsg([])}
          />
        )}
        {inputDialogMsg.msg && (
          <InputDialog
            title={inputDialogMsg.title}
            contentMsg={inputDialogMsg.msg}
            closeDialog={() => setInputDialogMsg([])}
            addDialog={(value) => {
              localStorage.setItem("formName", value);
              handleSubmit(onSubmit(value));
            }}
            errMsg="This is a required field"
            doneButton="Save Form"
          />
        )}
      </div>
    </div>
  );
}

export default FormContainer;
